document.addEventListener('click', function(event) {
    const drCloseBtn = event.target.closest('.dr_close');
    
    if (drCloseBtn) {
        event.preventDefault(); 
        
        if (window.innerWidth < 990) {
            const menuDetails = document.querySelector('header-drawer details');
            const menuDrawerSummary = document.querySelector('.header__icon.header__icon--menu');
            if (menuDetails && menuDetails.hasAttribute('open') && menuDrawerSummary) {
                menuDrawerSummary.click();
            }
        }
    }
});







document.querySelectorAll('.custom-add-to-cart-button').forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      let variantId = this.getAttribute('data-variant-id');

      let formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: {
              //'Source': 'Product data',
              //'Date Added': new Date().toLocaleDateString()
            },
          },
        ],
        sections: 'cart-drawer,cart-icon-bubble',
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((response) => {
          // Success block - button text reset removed from here

          if (document.querySelector('cart-drawer')) {
            const cartDrawer = document.querySelector('cart-drawer');

            fetch(`${routes.cart_url}?section_id=cart-drawer`)
              .then((res) => res.text())
              .then((html) => {
                const innerHTML = new DOMParser()
                  .parseFromString(html, 'text/html')
                  .querySelector('#CartDrawer').innerHTML;
                document.querySelector('#CartDrawer').innerHTML = innerHTML;

                cartDrawer.classList.remove('is-empty');
                cartDrawer.open();
              });

            if (response.sections && response.sections['cart-icon-bubble']) {
              const iconBubble = document.getElementById('cart-icon-bubble');
              if (iconBubble) iconBubble.innerHTML = response.sections['cart-icon-bubble'];
            }
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          // Error block - button text reset removed from here
        });
    });
  });





let selectedRemoveBtn = null;
let isConfirmed = false;

// Intercept REMOVE (CAPTURE PHASE)
document.addEventListener('click', function (e) {
  const removeBtn = e.target.closest('cart-remove-button button');

  if (removeBtn) {
    // agar confirm nahi kiya toh modal dikhao
    if (!isConfirmed) {
      e.preventDefault();
      e.stopImmediatePropagation();

      selectedRemoveBtn = removeBtn.closest('cart-remove-button');

      const modal = document.getElementById('drawerDeleteModal');
      if (modal) modal.style.display = 'block';
    }
  }
}, true); // 👈 capture phase

// CANCEL
document.addEventListener('click', function (e) {
  if (e.target.id === 'drawerCancelDelete') {
    const modal = document.getElementById('drawerDeleteModal');
    if (modal) modal.style.display = 'none';

    // 🔥 reset properly
    selectedRemoveBtn = null;
    isConfirmed = false;
  }
});

// CONFIRM DELETE
document.addEventListener('click', function (e) {
  if (e.target.id === 'drawerConfirmDelete') {
    if (selectedRemoveBtn) {
      isConfirmed = true;

      // original click trigger
      selectedRemoveBtn.querySelector('button').click();
    }

    const modal = document.getElementById('drawerDeleteModal');
    if (modal) modal.style.display = 'none';

    // 🔥 VERY IMPORTANT: reset after small delay
    setTimeout(() => {
      isConfirmed = false;
      selectedRemoveBtn = null;
    }, 300);
  }
});


// document.addEventListener('DOMContentLoaded', function() {
//   const customActionButtons = document.querySelector('.custom-action-buttons');
//   const productFormSubmit = document.querySelector('.product-form__submit');
//   const devFooter = document.querySelector('.dev-footer');


//   if (!customActionButtons || !productFormSubmit || !devFooter) return;

//   function toggleCustomButtons() {
//     const submitRect = productFormSubmit.getBoundingClientRect();
//     const footerRect = devFooter.getBoundingClientRect();

//     // Condition 1: .product-form__submit ka bottom viewport ke top se upar ja chuka hai (<= 0)
//     const isPastSubmitButton = submitRect.bottom <= 0;

//     // Condition 2: .dev-footer ka top abhi viewport ke bottom (window height) se niche hai (> window.innerHeight)
//     const isBeforeFooter = footerRect.top > window.innerHeight;

//     // Agar Submit button upar nikal gaya hai OR Footer abhi tak screen par nahi dikha hai
//     if (isPastSubmitButton && isBeforeFooter) {
//       customActionButtons.classList.add('is-show');
//     } else {
//       // Jaise hi Footer screen par aayega (ya user wapas upar submit button par jayega), class remove ho jayegi
//       customActionButtons.classList.remove('is-show');
//     }
//   }

//   // Scroll event listener (requestAnimationFrame ke sath smooth rendering ke liye)
//   window.addEventListener('scroll', function() {
//     window.requestAnimationFrame(toggleCustomButtons);
//   });

//   // Page load hone par bhi ek baar check kar lega (in case user middle page pe refresh kare)
//   toggleCustomButtons();
// });






document.addEventListener('DOMContentLoaded', function() {
  const customActionButtons = document.querySelector('.custom-action-buttons');
  // const productFormSubmit = document.querySelector('.product-form__submit'); // Commented
  const devFooter = document.querySelector('.dev-footer');

  if (!customActionButtons || !devFooter) return;

  function toggleCustomButtons() {
    // const submitRect = productFormSubmit.getBoundingClientRect(); // Commented
    const footerRect = devFooter.getBoundingClientRect();

    // Condition 1: .product-form__submit logic commented out
    // const isPastSubmitButton = submitRect.bottom <= 0;

    // Condition 2: .dev-footer ka top viewport ke bottom se niche hai (> window.innerHeight)
    const isBeforeFooter = footerRect.top > window.innerHeight;

    // Ab sirf Footer wali condition check hogi
    if (isBeforeFooter) {
      customActionButtons.classList.add('is-show');
    } else {
      // Jaise hi Footer screen par aayega, class remove ho jayegi
      customActionButtons.classList.remove('is-show');
    }
  }

  // Scroll event listener
  window.addEventListener('scroll', function() {
    window.requestAnimationFrame(toggleCustomButtons);
  });

  // Initial check
  toggleCustomButtons();
});

